import React from "react";

class Program extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    document.title =
      "ICITA 2026 | Programme - 21st International Conference on Information Technology and Applications (ICITA)";
  }

  render() {
    const { data } = this.state;
    return (
      <div>
        <div className="intro">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <div className="section_title_container text-center">
                  <div className="section_title">
                    <h1>Programme </h1>
                  </div>
                </div>
                <div className="intro_text text-center">
                  <div className="row speakers_row">
                    <p align="left">
                      Please note, that sessions on 14th October 2026 will be
                      held in person at <br></br>
                      Hilton Helsinki,Kalastajatorpantie 1, 00330 Helsinki,
                      Finland <br></br>
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d150315.93176310105!2d24.753871409972486!3d60.246715382468665!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46920a06c1432ec1%3A0xc389ebcb13e5ce5e!2sHilton%20Helsinki%20Kalastajatorppa!5e1!3m2!1sen!2suk!4v1785058203807!5m2!1sen!2suk"
                        width="600"
                        height="450"
                        style={{ border: "0" }}
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="strict-origin-when-cross-origin"
                      ></iframe>
                      <br></br>
                    </p>
                  </div>
                  <div className="row speakers_row">
                    <a
                      href="https://www.icita.world/files/ICITA_2026_finland.pdf"
                      target="_blank"
                    >
                      Click here to access the programme for ICITA 2026
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Program;
